//#region Imports

import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';

//#endregion

@Injectable({
  providedIn: 'root',
})
export class GlobalSpinnerService implements OnDestroy {

  constructor(
    private readonly router: Router,
  ) {}

  //#region Private Properties

  private routerEventSubscription?: Subscription;

  private lastUrl?: string;

  private keepLoading: boolean = false;

  protected isLoading: boolean = false;

  //#endregion

  //#region Public Methods

  public ngOnDestroy(): void {
    this.routerEventSubscription?.unsubscribe();
  }

  public initialize(): void {
    this.routerEventSubscription = this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        const currentUrl = event.url.split('?')[0];

        if (
          this.lastUrl !== currentUrl &&
          (!this.isLoading || !this.keepLoading)
        ) {
          this.startSpinner();
          this.keepLoading = false;
        }

        this.lastUrl = currentUrl;
      } else if ((event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) && !this.keepLoading && this.isLoading) {
        setTimeout(() => {
          if (!this.keepLoading)
            this.endSpinner();
        }, 400);
      }
    });
  }

  public showSpinner(): void {
    this.keepLoading = true;

    if (!this.isLoading)
      this.startSpinner();
  }

  public hideSpinner(): void {
    this.keepLoading = false;

    if (this.isLoading)
      this.endSpinner();
  }

  private startSpinner(): void {
    this.isLoading = true;
    const spinnerElement = document.getElementById('main-loading');

    if (spinnerElement) {
      spinnerElement.classList.add('!flex');
      spinnerElement.classList.add('!opacity-100');
    }
  }

  private endSpinner(): void {
    const spinnerElement = document.getElementById('main-loading');

    if (spinnerElement) {
      spinnerElement.classList.remove('!flex');
      spinnerElement.classList.remove('!opacity-100')
    }

    this.isLoading = false;
  }

  //#endregion

}
